<template lang="pug">
  a-input(
    :value="projectSearchText"
    :defaultValue="projectSearchText"
    @change="setProjectSearchTextWith"
    :placeholder="$t('components.project_searcher.tpl.placeholder')"
    ref="searchInput"
    name="projectSearchText"
  )
    a-icon(
      slot="prefix"
      type="search"
    )
    a-icon(
      slot="suffix"
      type="close-circle"
      @click="setProjectSearchText(); focusSearchInput();"
      v-if="projectSearchText"
    )
</template>

<script>
import {
  mapState,
  mapMutations,
} from 'vuex';

export default {
  computed: {
    ...mapState([
      'projectSearchText',
    ]),
  },
  mounted() {
    this.focusSearchInput();
  },
  methods: {
    ...mapMutations([
      'setProjectSearchText',
    ]),
    setProjectSearchTextWith(event) {
      this.setProjectSearchText(event.target.value);
    },
    focusSearchInput() {
      this.$nextTick(() => {
        if (this.$refs.searchInput) this.$refs.searchInput.focus();
      });
    },
  },
};
</script>

<style scoped>
.anticon-close-circle {
  cursor: pointer;
  color: #ccc;
  transition: color 0.3s;
  font-size: 12px;
}
.anticon-close-circle:hover {
  color: #999;
}
.anticon-close-circle:active {
  color: #666;
}
</style>
